module.exports = __webpack_public_path__ + "img/余额.17ff3264.png";